import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { Member } from "./records";

const slice = createEntitySlice<Member>({ name: "roomMembers" });

export const reducer = slice.reducer;
export const actions = slice.actions;
